<i18n src="@/locales/models/liquidation.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6 flex flex-row" v-if="load_data">
    <div :class="{ 'basis-full': !show_liquidation, 'basis-1/4': show_liquidation }">
      <badge-default class="mb-2" :label="`Liquidaciones: ${total_liquidations}`" />
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table
              :class="[show_liquidation ? 'hidden md:table' : 'table']"
              class="min-w-full"
            >
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell sticky z-10">
                    {{ $t("model.liquidation.week") }}
                  </th>
                  <th
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.liquidation.registered_at") }}
                  </th>
                  <th
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.liquidation.total_amount") }} ($)
                  </th>
                  <th scope="col" class="table-header-cell sticky z-10">
                    {{ $t("model.liquidation.liquidation_code") }}
                  </th>
                  <th
                    v-if="!show_liquidation"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.liquidation.number_boxes") }}
                  </th>
                  <th
                    v-if="!show_liquidation"
                    scope="col"
                    class="table-header-cell sticky z-10"
                  >
                    {{ $t("model.liquidation.number_kg") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  v-for="(liquidation, index) in liquidations"
                  :key="index"
                  :class="{
                    'table-row': true,
                    'bg-gray-300':
                      show_liquidation &&
                      liquidation.liquidation_code == this.liquidation_details[0]?.liquidation_code
                  }"
                >
                  <td class="table-cell">{{ liquidation.week }}</td>
                  <td class="table-cell">
                    {{ dateFormatter(liquidation.registered_at) }}
                  </td>
                  <td class="table-cell">
                    {{ numberWithPrecision(liquidation.total_amount) }}
                  </td>
                  <td class="table-cell">
                    <button
                      @click.prevent="showLiquidation(liquidation)"
                      class="link"
                    >
                      {{ liquidation.liquidation_code }}
                    </button>
                  </td>
                  <td v-if="!show_liquidation" class="table-cell">
                    {{ numberWithPrecision(liquidation.number_boxes) }}
                  </td>
                  <td v-if="!show_liquidation" class="table-cell">
                    {{ numberWithPrecision(liquidation.number_kg) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <table-paginator
        v-model="current_page"
        :total_rows="total_liquidations"
        :rows_per_page="rows_per_page"
      />
    </div>
    <div v-if="show_liquidation && liquidation_details" class="basis-3/4 pl-4 mt-8">
      <a @click.prevent="show_liquidation = false" class="btn-white">
        <i class="fa fa-angle-left mr-2"></i>Volver a la lista de liquidaciones
      </a>
      <table class="table min-w-full mt-8">
        <thead class="table-header">
          <tr>
            <th
              scope="col"
              class="table-header-cell sticky z-10"
              >
              {{ $t("model.liquidation.number_boxes") }}
            </th>
            <th
              scope="col"
              class="table-header-cell sticky z-10"
              >
              {{ $t("model.liquidation.number_kg") }}
            </th>
            <th
              scope="col"
              class="table-header-cell sticky z-10"
              >
              {{ $t("model.liquidation.total_amount") }} ($)
            </th>
            <th
              scope="col"
              class="table-header-cell sticky z-10"
              >
              {{ $t("model.liquidation.crop_category_id") }}
            </th>
            <th
              scope="col"
              class="table-header-cell sticky z-10"
              >
              {{ $t("model.liquidation.crop_size_id") }}
            </th>
            <th
              scope="col"
              class="table-header-cell sticky z-10"
              >
              {{ $t("model.liquidation.crop_variety_id") }}
            </th>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr
            v-for="(liquidation_detail, index) in liquidation_details"
            :key="index"
            :class="{
              'table-row': true,
            }"
          >
            <td class="table-cell">
              {{ numberWithPrecision(liquidation_detail.number_boxes) }}
            </td>
            <td class="table-cell">
              {{ numberWithPrecision(liquidation_detail.number_kg) }}
            </td>
            <td class="table-cell">
              {{ numberWithPrecision(liquidation_detail.total_amount) }}
            </td>
            <td class="table-cell">
              {{ liquidation_detail.crop_category?.name }}
            </td>
            <td class="table-cell">
              {{ liquidation_detail.crop_size?.name }}
            </td>
            <td class="table-cell">
              {{ liquidation_detail.crop_variety?.name }}
            </td>
          </tr>
        </tbody>
        <tfoot class="table-footer">
          <tr>
            <td class="table-footer-cell">
              {{ numberWithPrecision(total_liquidation_detail.number_boxes) }}
            </td>
            <td class="table-footer-cell">
              {{ numberWithPrecision(total_liquidation_detail.number_kg) }}
            </td>
            <td class="table-footer-cell">
              {{ numberWithPrecision(total_liquidation_detail.total_amount) }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/liquidations/query_by_provider/show_provider.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "PRODReportingProcessShowReportsDetails",
  components: { TablePaginator },
  props: {
    provider_id: { required: true },
    agro_exporter_process_id: { required: true },
    agro_exporter_id: { required: true },
    provider_type: { required: true }
  },
  data() {
    return {
      load_data: false,
      current_page: 1,
      total_liquidations: 0,
      rows_per_page: 14,
      show_liquidation: false,
      liquidation_details: null,
      liquidations: [],
    };
  },
  computed: {
    total_liquidation_detail: function () {
      if (!this.liquidation_details) return { number_boxes: 0, number_kg: 0, total_amount: 0 }
      return {
        number_boxes: this.sumDetails("number_boxes"),
        number_kg: this.sumDetails("number_kg"),
        total_amount: this.sumDetails("total_amount")
      }
    }
  },
  created() {
    this.fetchTotalPages();
    this.fetchLiquidations();
  },
  methods: {
    async showLiquidation(liquidation) {
      await this.fetchLiquidation(liquidation);
      this.show_liquidation = true;
    },
    async fetchLiquidation(liquidation) {
      let { data } = await Requester.fetchLiquidation(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id,
        liquidation.liquidation_code
      );
      this.liquidation_details = data;
    },
    fetchLiquidations: async function () {
      let response = await Requester.fetchLiquidations(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id,
        this.current_page,
        this.rows_per_page
      );
      this.liquidations = response.data;
    },
    fetchTotalPages: async function () {
      let response = await Requester.fetchLiquidationsTotal(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.total_liquidations = response.data;
      this.load_data = true;
    },
    sumDetails: function (key) {
      if (!this.liquidation_details) return 0;
      
      let sum = 0;
      this.liquidation_details.forEach(detail => {
        sum += detail[key];
      });
      return sum;
    }
  },
  watch: {
    current_page: function () {
      this.fetchLiquidations();
    }
  }
};
</script>
